import { useEffect } from 'react';
import { RotatingLines } from 'react-loader-spinner';
import NavbarPlaceholder from '../components/NavbarPlaceholder';
import useDeviceSize from '../hooks/useDeviceSize';
import useEbcSolarStore from '../store/ebc-solar-store';
import { WidgetState } from '../types/states';

export const SearchingAddress = () => {
    const { width, height, isMobile } = useDeviceSize();

    const setState = useEbcSolarStore((state) => state.setState);

    useEffect(() => {
        setTimeout(() => {
            setState(WidgetState.PIN_ROOF);
        }, 3000);
    }, []);

    return (
        <div
            style={{
                minWidth: '100%',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <NavbarPlaceholder />
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginTop: '4rem',
                    gap: '2rem',
                    paddingBottom: '2rem',
                }}
            >
                <div>
                    <img src='https://storage.googleapis.com/ebc-solar-quotation-widget/assets/Solar-Graphic-1.png' width={isMobile ? '256px' : '400px'} height='auto' />
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '1rem',
                    }}
                >
                    <div>
                        <RotatingLines strokeColor='#26A757' strokeWidth='5' animationDuration='0.75' width='64' visible={true} />
                    </div>
                    <h1
                        style={{
                            fontSize: '36px',
                            fontWeight: 600,
                            textAlign: 'center',
                        }}
                    >
                        Searching for your address
                    </h1>
                </div>
            </div>
        </div>
    );
};

export default SearchingAddress;
